import React, { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import Cookies from 'js-cookie';
import LoadingCop from '../Components/Loading';
import { useGlobalContext } from '../Components/Context';
import axios from 'axios';
export const instance=axios.create({
  baseURL:`${process.env.REACT_APP_API_URL}/api/v1`,
  timeout:20000,
  timeoutErrorMessage:'timeout',
  headers:{
    'Content-Type': 'application/json',
}
})
export default function AxiosErrorComp() {
  const {loading,setloading}=useGlobalContext()
  const pendingRequests = new Map();
 console.log("s")
       useEffect(()=>{
        console.log("dddd")
        instance.interceptors.request.use(
          function (config) {
            const noLoading = instance.defaults.interceptorOptions && instance.defaults.interceptorOptions.noLoading;
            const Token = Cookies.get("AuthToken");
            config.headers.authorization = `Bearer ${Token}`;
            pendingRequests.set(`${config.method} ${config.url}`, config)
      
            if(!noLoading){
              setloading(true);
              return config;
            }
            return config;
          },
          (error) => {
            toast.error(error);
            setloading(false);
          }
        );
        instance.interceptors.response.use(
          function (response) {
            pendingRequests.delete(`${response.config.method} ${response.config.url}`);
            if (pendingRequests.size === 0) {
              setloading(false);
            }
            return response;
          },
              error=>{
                  setloading(false)
                let status=error.response?.status
                let errMes=error?.response?.data?.error?.description
                let message=error.response?.statusText
                let AxiosError=error?.message
                
                 if(status===400){
                  return Promise.reject(error),toast.error(errMes)
                }else if(status==403){
                  
                  return Promise.reject(error),toast.error(message)          
                }else if(status==404){
                  
                      return Promise.reject(error),toast.error('آدرسی یافت نشد') ,toast.error(errMes)        
                    }
                    else if(status==409){
                  
                      return Promise.reject(error) ,toast.error(errMes)        
                    }
                    else if(status==415){
                  
                      return Promise.reject(error),toast.error('نوع داده ارسالی خوانا نیست')         
                    }
      
                      else if(status==429){
                  toast(message)
                }else if(status==401){
                  window.location.href="/"
                 Cookies.remove('AuthToken')
                 localStorage.clear()
                  return Promise.reject(error),toast.error('توکن منقضی شده')          }
                  else if(status==504){
                    // window.location.href="/"
                   // Cookies.remove('AuthToken')
        
                    return Promise.reject(error),toast.error('مشکل در برقراری ارتباط با سرور')          }
                    else{
                      toast.error(error)
                    }
                 
                
                
                return Promise.reject(error);
              }
            );
      
       },[])
       
  
  return (
    <div>
      <ToastContainer  theme='dark' rtl position='bottom-left' toastStyle={{fontSize:'13px',borderRadius:'10px',fontWeight:'bold'}}/>
      <div>
        {loading&&<LoadingCop/>}
      </div>
    </div>
  )
}
